<template>
    <span class="badge rounded-pill bg-primary runoff-badge">Runoff</span>
</template>

<script>
export default {
    name: "runoff-badge",

    props: [],

    mixins: [],

    data: function () {
        return {}
    },


    computed: {},

    methods: {}

}
</script>

<style scoped>
.runoff-badge{
     /*badge-color: #396f3a;*/
}
</style>
